<template>
  <div class="yly-product-create">
    <!-- 任务策略 -->
    <el-card class="section-card" shadow="never">
      <template #header>
        <div class="section-header">任务策略</div>
      </template>
      <div class="section-body">
        <!-- <div class="form-row">
          <div class="field-label">引用策略或任务</div>
          <div class="field-control">
            <el-radio-group v-model="taskPolicyType" size="small">
              <el-radio-button label="near30">近30天任务</el-radio-button>
              <el-radio-button label="strategy">策略</el-radio-button>
            </el-radio-group>
          </div>
        </div> -->
        <!-- <div v-show="taskPolicyType === 'near30'" class="form-row">
          <div class="field-label">引用历史任务</div>
          <div class="field-control field-control-inline">
            <el-select v-model="historyTaskId" filterable clearable placeholder="请输入任务名称搜索" style="width: 360px"
              size="small">
              <el-option v-for="item in historyTaskOptions" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-button type="primary" size="small">复用</el-button>
          </div>
        </div>
        <div v-show="taskPolicyType === 'near30'" class="tip-text">选择近30天历史任务快速回显。</div> -->
        <div v-show="taskPolicyType === 'strategy'" class="form-row">
          <div class="field-label">策略名称</div>
          <div class="field-control field-control-inline">
            <el-input placeholder="不填为全搜索，填入为模糊搜索" size="small" style="width: 360px" v-model="selectStrategyName"
              clearable>
            </el-input>
            <el-button type="success" size="small" @click="librarystrategyListFun">查询策略</el-button>
          </div>
        </div>
        <div v-show="taskPolicyType === 'strategy'" class="form-row">
          <div class="field-label">引用策略</div>
          <div class="field-control field-control-inline">
            <el-select v-model="strategyId" filterable clearable placeholder="请输入策略名称搜索" style="width: 360px"
              size="small">
              <el-option v-for="item in strategyOptions" :key="item.id" :label="item.strategyName" :value="item.id" />
            </el-select>
            <el-button type="warning" size="small" @click="fuyongFun()">复用</el-button>
          </div>
        </div>
        <div v-show="taskPolicyType === 'strategy'" class="tip-text">选择策略快速回显。</div>
      </div>
    </el-card>

    <!-- 商品库 -->
    <el-card class="section-card" shadow="never">
      <template #header>
        <div class="section-header">商品库</div>
      </template>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">工作台来源</div>
          <div class="field-control">
            <el-radio-group v-model="workspaceSource" size="small">
              <el-radio-button label="old" disabled="ture">旧版工作台</el-radio-button>
              <el-radio-button label="new">新版工作台</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label">商品库类型</div>
          <div class="field-control">
            <el-radio-group v-model="productLibraryType" size="small">
              <el-radio-button label="drama">短剧调试库</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row align-start">
          <div class="field-label">指定商品库</div>
          <div class="field-control">
            <el-button type="primary" size="small" @click="handleSelectLibrary">已选商品库</el-button>
            <div v-if="spData" class="product-library-box">
              <div class="product-library-card">
                <div class="product-library-close" @click="clearLibrary">×</div>
                <div class="product-library-line">商品库名称：{{ spData.name }}</div>
                <div class="product-library-line">商品库ID：{{ spData.platformId }}</div>
                <!-- <div class="product-library-line">所属账户ID：{{ selectedLibrary.accountId }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 商品投放载体 -->
    <el-card class="section-card" shadow="never">
      <template #header>
        <div class="section-header">商品投放载体</div>
      </template>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">投放载体</div>
          <div class="field-control">
            <el-radio-group v-model="productList[0].profession.adCarrierTxt" size="small">
              <el-radio-button :label="'字节小程序'">字节小程序</el-radio-button>
              <el-radio-button :label="'微信小程序'">微信小程序</el-radio-button>
              <el-radio-button :label="'端原生组件'">端原生组件</el-radio-button>
              <el-radio-button :label="'安卓/iOS应用'">安卓/iOS应用</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form-row">
          <div class="field-label"></div>
          <div class="field-control">
            <el-button type="warning" size="small" @click="handleAddSpecialId">请输入专辑ID</el-button>
          </div>
        </div>
        <el-table :data="playletIds" border class="special-id-table" max-height="320">
          <el-table-column label="专辑ID" min-width="220" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template #default="{ $index }">
              <el-button type="text" size="small" @click="removeSpecialId($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 商品基础配置 -->
    <el-card class="section-card" shadow="never">
      <template #header>
        <div class="section-header">商品基础配置</div>
      </template>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">版权方主体名称</div>
          <div class="field-control">
            <el-input v-model="productList[0].profession.copyrightOwner" placeholder="请输入版权方主体名称" style="width: 320px"
              size="small" />
          </div>
        </div>
        <div class="form-row">
          <div class="field-label">变现模式</div>
          <div class="field-control">
            <el-radio-group v-model="productList[0].profession.hasPaidContentTxt" size="small">
              <el-radio-button :label="'流量变现'" />
              <el-radio-button :label="'付费变现'" />
            </el-radio-group>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 多商品配置 -->
    <!-- <el-card class="section-card" shadow="never">
      <template #header>
        <div class="section-header">多商品配置</div>
      </template>
      <div class="section-body">
        <el-button type="primary" size="small" class="batch-select-btn" @click="handleBatchSelect">
          批量选择商品图片
        </el-button>

        <div class="table-wrapper">
          <el-table :data="productRows" border style="width: 100%" max-height="520"
            :header-cell-style="headerCellStyle">
            <el-table-column label="批量设置模板" min-width="160" fixed>
              <template #default>
                <span class="copy-link" @click="copyTemplate">复制到其他商品</span>
              </template>
            </el-table-column>

            <el-table-column label="商品图片" min-width="130">
              <template #default="{ row, $index }">
                <div class="cover-cell" @click="handleSelectCover($index)">
                  <img v-if="row.cover" :src="row.cover" class="cover-img" alt="商品图片" />
                  <span v-else class="cover-placeholder">+</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="类目" min-width="220">
              <template #default="{ row }">
                <el-select v-model="row.category" placeholder="请选择类目" style="width: 100%" size="small">
                  <el-option label="漫剧 / 其他剧情 / 其他" value="漫剧 / 其他剧情 / 其他" />
                  <el-option label="短剧 / 现代 / 情感" value="短剧 / 现代 / 情感" />
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="短剧男女频" min-width="120">
              <template #default="{ row }">
                <el-select v-model="row.genderType" placeholder="其他" style="width: 100%" size="small">
                  <el-option label="其他" value="其他" />
                  <el-option label="男频" value="男频" />
                  <el-option label="女频" value="女频" />
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="起始解锁集数" min-width="160">
              <template #default="{ row }">
                <el-input-number v-model="row.unlockEpisode" :min="1" :max="9999" controls-position="right"
                  style="width: 100%" size="small" />
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="140" fixed="right">
              <template #default="{ $index }">
                <el-button type="text" size="small" @click="refreshRow($index)">刷新</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="info-banner">
          <el-icon class="info-icon">
            <InfoFilled />
          </el-icon>
          <span>根据商品ID分类，本次创建{{ productRows.length }}个商品</span>
        </div>
      </div>
    </el-card> -->

    <!-- 单商品列表信息 -->
    <el-card class="section-card" shadow="never">
      <template #header>
        <div class="section-header">单商品列表信息</div>
      </template>
      <div class="section-body">
        <el-table :data="productList" border style="width: 100%" max-height="400" :header-cell-style="headerCellStyle"
          empty-text="暂无数据">
          <el-table-column label="商品图片" min-width="80">
            <template #default="{ row }">
              <div class="cover-cell">
                <img v-if="row.imageUrl" :src="row.imageUrl" class="cover-img" alt="商品图片" />
                <el-icon v-else class="cover-placeholder">
                  <InfoFilled />
                </el-icon>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="playletId" label="专辑ID" min-width="180" show-overflow-tooltip /> -->
          <!-- <el-table-column prop="name" label="商品名称" min-width="100">
            <el-input placeholder="请输入内容" v-model="productList[0].name" clearable> </el-input>
          </el-table-column> -->
          <el-table-column prop="category" label="类目" min-width="110">
            <el-cascader v-model="ssssf" :options="ssssfoptions" @change="handleChange"></el-cascader>
          </el-table-column>
          <el-table-column label="短剧男女频" min-width="60">
            <el-select v-model="productList[0].profession.playletGender" placeholder="请选择">
              <el-option v-for="item in playletGenderData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-table-column>
          <el-table-column label="总集数" min-width="60">
            <el-input placeholder="请输入集数" v-model="productList[0].profession.playletNum" clearable> </el-input>
          </el-table-column>
          <el-table-column label="起始解锁集数" min-width="90">
            <el-input-number v-model="productList[0].profession.startPayPlaylet" :min="1" :max="100"
              label="描述文字"></el-input-number>
          </el-table-column>
          <el-table-column label="单集价格(元)" min-width="60">
            <el-input placeholder="请输入单集价格" v-model="productList[0].priceInfo.price" clearable> </el-input>
          </el-table-column>
          <el-table-column label="单集剧集时长(分钟)" min-width="80">
            <el-input placeholder="请输入单集剧集时长" v-model="productList[0].profession.playletDuration" clearable> </el-input>
          </el-table-column>
        </el-table>
      </div>
      <div class="info-banner">
        <el-icon class="info-icon">
          <InfoFilled />
        </el-icon>
        <span>根据商品ID分类，本次创建{{ playletIds.length }}个商品</span>
      </div>
    </el-card>


    <!-- 添加商品或保存策略 -->
    <el-card class="section-card" shadow="never">
      <template #header>
        <div class="section-header">添加商品或保存策略</div>
      </template>
      <div class="section-body">
        <div class="form-row">
          <div class="field-label">
            <el-button type="primary" icon="el-icon-check" size="mini"
              @click="libraryproductCreateFun()">添加商品</el-button>
          </div>
          <div class="field-control">
            <el-button type="success" icon="el-icon-star-off" size="mini"
              @click="saveStrategyView = true">保存策略并添加商品</el-button>
          </div>
        </div>

      </div>
    </el-card>

    <!-- 保存策略弹窗 -->
    <el-dialog v-model="saveStrategyView" title="保存策略" width="30%">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="策略名称">
          <el-input v-model="saveStrategyName" placeholder="请输入策略名称" size="mini"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="librarystrategySaveFun()">确定</el-button>
          <el-button size="mini" @click="saveStrategyView = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 添加专辑ID弹窗 -->
    <el-dialog v-model="addSpecialView" title="添加专辑ID" width="40%">
      <el-input v-model="specialIdInput" type="textarea" :rows="10" placeholder="请输入专辑ID，一行一个" />
      <template #footer>
        <el-button @click="clearSpecialInput">清空</el-button>
        <el-button type="primary" @click="confirmSpecialId">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import { InfoFilled } from '@element-plus/icons-vue'
import { reactive, toRefs, watch, ref } from 'vue'
import { libraryproductCreate, librarystrategySave, librarystrategyList } from '@/request/new/ylyBatch'
import { select } from '@/request/new/batchManagement';

export default {
  name: 'ylyProductCreate',
  components: { InfoFilled },
  props: ['spData'],
  // emits: ['update', 'submit'],
  setup(props, context) {
    const state = reactive({
      // 从父组件传入的商品库信息
      spData: props.spData || {},
      // 任务策略
      taskPolicyType: 'strategy',
      historyTaskId: '',
      strategyId: '',
      selectStrategyName: '',
      strategyOptions: [],
      // 商品库
      workspaceSource: 'new',
      productLibraryType: 'drama',
      selectedLibrary: null,
      // 商品投放载体
      adCarrier: '端原生组件',
      //专辑id
      playletIds: [],
      // 专辑ID弹窗
      addSpecialView: false,
      specialIdInput: '',
      // 多商品配置
      productRows: [],
      // 保存策略的名称
      saveStrategyName: '',
      // 保存策略弹窗控制
      saveStrategyView: false,
      // 单商品列表信息
      productList: [{
        name: "未同步商品名称",
        imageUrl: "https://tos.mobgi.com/tos_beijing/material_3/20260803/12400094424/12400153582/b2e28bb5be5fea49e504845404f4ff9e.png",
        firstCategory: '',
        subCategory: '',
        thirdCategory: '',
        firstCategoryId: '',
        subCategoryId: '',
        thirdCategoryId: '',
        priceInfo: {
          price: 1
        },
        profession: {
          adCarrierTxt: '端原生组件',
          adCarrier: [],
          copyrightOwner: "抖音视界剧场",
          playletGender: 3,
          playletNum: 1,
          hasPaidContentTxt: '流量变现',
          hasPaidContent: [],
          playletDuration: 1,
          startPayPlaylet: 1
        }

      },],
      productList2: [{
        name: "未同步商品名称",
        imageUrl: "https://tos.mobgi.com/tos_beijing/material_3/20260803/12400094424/12400153582/b2e28bb5be5fea49e504845404f4ff9e.png",
        firstCategory: '',
        subCategory: '',
        thirdCategory: '',
        firstCategoryId: '',
        subCategoryId: '',
        thirdCategoryId: '',
        priceInfo: {
          price: 1
        },
        profession: {
          adCarrierTxt: '端原生组件',
          adCarrier: [],
          copyrightOwner: "抖音视界剧场",
          playletGender: 3,
          playletNum: 1,
          hasPaidContentTxt: '流量变现',
          hasPaidContent: [],
          playletDuration: 1,
          startPayPlaylet: 1
        }

      },],
      // 类目
      ssssfoptions: [
        {
          value: 2039,
          label: '漫剧',
          children: [
            {
              value: 203907,
              label: '其他剧情',
              children: [
                {
                  value: 20390701,
                  label: '其他',
                }
              ]
            }
          ]
        }
      ],
      ssssf: [],
      // 男女频
      playletGenderData: [
        {
          value: 1,
          label: '男频',
        },
        {
          value: 2,
          label: '女频',
        },
        {
          value: 3,
          label: '其他',
        }
      ],
      // 历史任务下拉
      historyTaskOptions: [],
      // 表头样式
      headerCellStyle: {
        background: '#fafafa',
        color: '#303133',
        fontWeight: 600,
      },

      handleChange: (value) => {
        // state.ssssf 是按顺序的 value 数组，如 [2039, 203907, 20390701]
        const labels = []
        let children = state.ssssfoptions
        state.ssssf.forEach((v) => {
          const node = (children || []).find((item) => item.value == v)
          if (node) {
            labels.push(node.label)
            children = node.children
          }
        })
        const [firstCategory, subCategory, thirdCategory] = labels
        const [firstCategoryId, subCategoryId, thirdCategoryId] = state.ssssf
        if (state.productList[0]) {
          state.productList[0].firstCategory = firstCategory
          state.productList[0].subCategory = subCategory
          state.productList[0].thirdCategory = thirdCategory
          state.productList[0].firstCategoryId = firstCategoryId
          state.productList[0].subCategoryId = subCategoryId
          state.productList[0].thirdCategoryId = thirdCategoryId
        }
        console.log('触发', state.ssssf)
      },


      // ==========选择商品库==========
      handleSelectLibrary: () => {
        // 打开选择商品库弹窗逻辑，等待接口
        console.log('打开选择商品库弹窗')
      },

      // ==========清除商品库==========
      clearLibrary: () => {
        state.selectedLibrary = null
      },

      // ==========添加短剧专项ID==========
      handleAddSpecialId: () => {
        state.specialIdInput = ''
        state.addSpecialView = true
      },

      // ==========清空专辑ID输入==========
      clearSpecialInput: () => {
        state.specialIdInput = ''
      },

      // ==========确定专辑ID==========
      confirmSpecialId: () => {
        const ids = state.specialIdInput.split('\n').map((s) => s.trim()).filter((s) => !!s)
        state.playletIds = ids
        state.addSpecialView = false
      },

      // ==========移除短剧专项ID==========
      removeSpecialId: (index) => {
        state.playletIds.splice(index, 1)
      },

      // ==========批量选择商品图片==========
      handleBatchSelect: () => {
        // 打开批量选择商品图片弹窗逻辑，等待接口
        console.log('打开批量选择商品图片弹窗')
      },

      // ==========选择商品封面==========
      handleSelectCover: (index) => {
        // 打开选择封面弹窗逻辑，等待接口
        console.log('选择商品封面', index)
      },

      // ==========复制模板==========
      copyTemplate: () => {
        if (state.productRows.length === 0) return
        const template = state.productRows[0]
        state.productRows.forEach((row) => {
          row.category = template.category
          row.genderType = template.genderType
          row.unlockEpisode = template.unlockEpisode
        })
      },

      // ==========刷新行==========
      refreshRow: (index) => {
        console.log('刷新行', index)
      },

      // ==========提交==========
      submit: () => {
        context.emit('submit', '111')
      },

      // ==========重置==========
      reset: () => {
        state.taskPolicyType = 'strategy'
        state.historyTaskId = ''
        state.workspaceSource = 'new'
        state.productLibraryType = 'drama'
        state.selectedLibrary = null
        state.adCarrier = '端原生组件'
        state.playletIds = []
        state.productList[0].profession.copyrightOwner = '抖音视界剧场'
        state.productRows = []
      },
      // 添加商品数据
      addSPDATAFun: () => {
        const datas = {
          accountId: props.spData.accountId,
          accountType: props.spData.accountType,
          platformId: props.spData.platformId,

          playletIds: state.playletIds,
          productInfo: state.productList[0]
        }
        datas.productInfo.profession.adCarrier = JSON.stringify([state.productList[0].profession.adCarrierTxt])
        datas.productInfo.profession.hasPaidContent = JSON.stringify([state.productList[0].profession.hasPaidContentTxt])
        return datas
      },

      // 添加商品
      libraryproductCreateFun: () => {
        if (state.playletIds.length == 0) {
          return ElMessage.error('请输入短剧专项id')
        }
        libraryproductCreate(state.addSPDATAFun()).then((res) => {
          if (res.code == 200) {
            ElMessage.success(res.msg)
            // 关闭组件弹窗
            context.emit('submit', 'dff')
          }
        })
      },
      // 保存策略添加商品
      librarystrategySaveFun: () => {
        if (state.playletIds.length == 0) {
          return ElMessage.error('请输入短剧专项id')
        }
        if (state.saveStrategyName == '') {
          return ElMessage.error('请输入策略名称')
        }
        const datas = {
          strategyName: state.saveStrategyName,
          requestParam: state.addSPDATAFun()
        }
        librarystrategySave(datas).then((res) => {
          if (res.code == 200) {
            ElMessage.success(res.msg)
            state.saveStrategyView = false
            // 关闭组件弹窗
            // context.emit('submit', 'dff')
            // 多请求一次，
            state.libraryproductCreateFun()
          }
        })
      },
      // 复用
      fuyongFun: () => {

        const item = state.strategyOptions.find((it) => it.id === state.strategyId) || null
        console.log('选中的策略item', item)
        if (!item) return ElMessage.error('请先引用策略')

        const requestParam = JSON.parse(item.requestParam || '{}')
        const productInfo = requestParam.product_info || {}
        const profession = productInfo.profession || {}

        const parseArrayText = (val) => {
          if (!val) return []
          if (Array.isArray(val)) return val
          if (typeof val === 'string') {
            try {
              const parsed = JSON.parse(val)
              return Array.isArray(parsed) ? parsed : [val]
            } catch (e) {
              return [val]
            }
          }
          return [val]
        }

        const target = state.productList[0]
        if (!target) return

        target.name = productInfo.name || ''
        target.imageUrl = productInfo.image_url || target.imageUrl
        target.firstCategory = productInfo.first_category || ''
        target.subCategory = productInfo.sub_category || ''
        target.thirdCategory = productInfo.third_category || ''
        target.firstCategoryId = productInfo.first_category_id || ''
        target.subCategoryId = productInfo.sub_category_id || ''
        target.thirdCategoryId = productInfo.third_category_id || ''
        target.priceInfo.price = productInfo.price_info?.price ?? target.priceInfo.price
        target.profession.adCarrierTxt = parseArrayText(profession.ad_carrier)[0] || ''
        target.profession.adCarrier = parseArrayText(profession.ad_carrier)
        target.profession.copyrightOwner = profession.copyright_owner || ''
        target.profession.playletGender = Number(profession.playlet_gender || target.profession.playletGender)
        target.profession.playletNum = Number(profession.playlet_num || target.profession.playletNum)
        target.profession.hasPaidContentTxt = parseArrayText(profession.has_paid_content)[0] || ''
        target.profession.hasPaidContent = parseArrayText(profession.has_paid_content)
        target.profession.playletDuration = Number(profession.playlet_duration || target.profession.playletDuration)
        target.profession.startPayPlaylet = Number(profession.start_pay_playlet || target.profession.startPayPlaylet)

        state.ssssf = [
          Number(productInfo.first_category_id),
          Number(productInfo.sub_category_id),
          Number(productInfo.third_category_id),
        ].filter((v) => v !== undefined && v !== null && v !== '')
        console.log('state.ssssf', state.ssssf)
        ElMessage.success('引用数据成功')
      },

    })

    // ==========查询策略列表（打开组件自动请求）==========
    const librarystrategyListFun = () => {
      const datas = {
        currentPage: 1,
        size: 200,
        platformId: props.platformId,
        strategyName: state.selectStrategyName,
      }

      librarystrategyList(datas).then((res) => {
        if (res.code == 200 || res.code == 0) {

          state.strategyOptions = res.data.data
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    librarystrategyListFun()

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      InfoFilled,
      librarystrategyListFun,

    }
  },
}
</script>

<style lang="scss" scoped>
.yly-product-create {
  padding: 0;
  background: transparent;
}

.section-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;

  :deep(.el-card__header) {
    padding: 14px 16px;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
  }

  :deep(.el-card__body) {
    padding: 16px;
  }
}

.section-header {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.section-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.align-start {
  align-items: flex-start;
}

.field-label {
  width: 120px;
  flex-shrink: 0;
  color: #606266;
  line-height: 32px;
}

.field-control {
  flex: 1;
  min-width: 0;
}

.field-control-inline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tip-text {
  margin-left: 136px;
  font-size: 12px;
  color: #909399;
}

.product-library-box {
  margin-top: 12px;
}

.product-library-card {
  position: relative;
  width: 220px;
  padding: 12px 14px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.product-library-close {
  position: absolute;
  top: 6px;
  right: 8px;
  color: #c0c4cc;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;

  &:hover {
    color: #909399;
  }
}

.product-library-line {
  margin-bottom: 6px;
  font-size: 13px;
  color: #303133;
  word-break: break-all;
}

.special-id-table {
  width: 100%;
}

.batch-select-btn {
  width: fit-content;
  margin-bottom: 12px;
}

.table-wrapper {
  overflow-x: auto;
}

.copy-link {
  color: #409eff;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    text-decoration: underline;
  }
}

.cover-cell {
  width: 88px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  border: 1px dashed #dcdfe6;

  &:hover {
    border-color: #409eff;
    background: #ecf5ff;
  }
}

.cover-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-placeholder {
  font-size: 28px;
  color: #c0c4cc;
}

.row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  background: #e8f1ff;
  color: #2f6fdd;
  font-size: 13px;
  margin-top: 12px;
}

.info-icon {
  font-size: 16px;
}
</style>
